import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsPercentageOrValueListAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetPercentageOrValue`,
    method: 'get',
  });
};

export type PreClaimsPercentageOrValueListResponse = {
  key: string; // 'P', 'A'
  value: string; // '%', '$'
}[];

export const fetchPreClaimsPercentageOrValueList = async (): Promise<PreClaimsPercentageOrValueListResponse> => {
  const response: AxiosResponse<PreClaimsPercentageOrValueListResponse> = await getPreClaimsPercentageOrValueListAPI();
  return response.data;
};
